module.exports = __webpack_public_path__ + "img/pricing.cd5faae9.svg";